import * as React from 'react';

const SvgArrowDown = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='25'
    height='24'
    viewBox='0 0 25 24'
    fill='none'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.79289 8.29289C5.40237 8.68342 5.40237 9.31658 5.79289 9.70711L11.7929 15.7071C12.1834 16.0976 12.8166 16.0976 13.2071 15.7071L19.2071 9.70711C19.5976 9.31658 19.5976 8.68342 19.2071 8.29289C18.8166 7.90237 18.1834 7.90237 17.7929 8.29289L12.5 13.5858L7.20711 8.29289C6.81658 7.90237 6.18342 7.90237 5.79289 8.29289Z'
      fill='var(--colorIconPrimary)'
    />
  </svg>
);

export default SvgArrowDown;
